import countdown from '../../vendor/countdown.js';

const CountdownTimer = {
	selectors: {
		containers: document.querySelectorAll(".js-countdown-timer")
	},

	init: function () {
		let self = this;
		self.selectors.containers.forEach(function (timerContainer) {
			var date = timerContainer.dataset.date;
			countdown.setLabels(
				timerContainer.dataset.singular,
				timerContainer.dataset.plural,
				timerContainer.dataset.last
			);
			countdown(
				new Date(date),
				function(ts) {
					timerContainer.innerHTML = ts.toHTML("strong");
				},
				countdown.DAYS|countdown.HOURS|countdown.MINUTES|countdown.SECONDS);
		})
	}
};

CountdownTimer.init();


